/**
*   工具函数集中管理
**/
var CgGlobalUtils = (function() {

    /**
     * @param { String } msg 
     * @param { Number } duration 
     */
    var Toast = function (msg, duration) {
        duration = isNaN(duration) ? 1000 : duration;
        const m = document.createElement('div');
        m.innerHTML = msg;
        m.style.cssText = "font-family:siyuan;max-width:60%;min-width: 150px;padding:0 14px;height: 40px;color: rgb(255, 255, 255);line-height: 40px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.7);font-size: 16px;";
        document.body.appendChild(m);
        setTimeout(function() {
            let d = 0.5;
            m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
            m.style.opacity = '0';
            setTimeout(function() {
                document.body.removeChild(m)
            }, d * 1000);
        }, duration);
    }

    /**
     * @param { String } url 
     */
    var includeLinkStyle = function(url) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = url;
        document.getElementsByTagName("head")[0].appendChild(link);
    }

    /**
     * 
     * @param { String } value 
     * @returns Boolean
     */
    var isMobileNumber = function (value) { 
        value = value.replace(/[^-|\d]/g, '');
        return (
          /^((\+86)|(86))?(1)\d{10}$/.test(value) || /^0[0-9-]{10,13}$/.test(value)
        );
    }
    /**
     * @returns Boolean
     */
    var isMobile = function () {
        return window.innerWidth <= 1024;
    }

    /**
     * 
     * @param { String } str 
     * @returns void
     */
    var copyToClipboard = function (str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
      
        const selection = document.getSelection();
      
        if (!selection) {
          return;
        }
      
        const selected = selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
      
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
      
        if (selected) {
            selection.removeAllRanges();
            selection.addRange(selected);
            Toast('Copy successfully!');
        } else {
            Toast('Copy failure!');
        }
    }
    var dateFormat = function(timestamp, format) {
        if (!timestamp) {
            return ''
        }
        let date = new Date(timestamp)
        const fullYear = date.getFullYear();
        const result = format.replace('YYYY', fullYear)
                    .replace('YY', fullYear.toString().slice(-2))
                    .replace('MM', (date.getMonth() + 1).toString().padStart(2, '0'))
                    .replace('DD', date.getDate().toString().padStart(2, '0'))
                    .replace('HH', date.getHours().toString().padStart(2, '0'))
                    .replace('mm', date.getMinutes().toString().padStart(2, '0'))
                    .replace('ss', date.getSeconds().toString().padStart(2, '0'))
                
        return result
    }

    /**
     * @param { Number } timestamp 
     * @returns  String
     */
    var formatTimestamp = function(timestamp) {
        var date = new Date(timestamp * 1000);
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        // var h = date.getHours() + ':';
        // var m = date.getMinutes() + ':';
        // var s = date.getSeconds();
        return Y+M+D;
    }

    var listeners = [];
    var doc = document;
    var observer;
    function observerEleReady(selector, fn) {
        // 储存选择器和回调函数
        listeners.push({
            selector: selector,
            fn: fn
        });
        if (!observer) {
            // 监听document变化
            observer = new MutationObserver(check);
            observer.observe(doc.documentElement, {
                childList: true,
                subtree: true
            });
        }
        // 检查该节点是否已经在DOM中
        check();
    }
    
    function check() {
        // 检查是否匹配已储存的节点
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            // 检查指定节点是否有匹配
            var elements = document.querySelectorAll(listener.selector);
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                // 确保回调函数只会对该元素调用一次
                if (!element.ready) {
                    element.ready = true;
                    // 对该节点调用回调函数
                    listener.fn.call(element, element);
                }
            }
        }
    }

    const isValidUrl = (url) => {
        const urlPattern = new RegExp(
          '^(?:http|ftp)s?://' + // http://, https://, ftp://, ftps://
          '(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\\.)+(?:[A-Z]{2,6}\\.?|[A-Z0-9-]{2,}\\.?)|' + // 域名
          'localhost|' + // localhost
          '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})' + // IP地址
          '(?::\\d+)?' + // 端口号
          '(?:/?|[/?]\\S+)$', 'i');
        return urlPattern.test(url);
    }

    /** 
     * 替换标签属性值
     * @param {Element | Element[]} ele - 元素对象
     * @param {string} sourceAttr - 源属性，
     * @param {string} replaceAttr - 替换属性，
     */
    const replaceEleAttribute=(ele,sourceAttr,replaceAttr)=>{
      if(!ele) return;
      if(!ele.forEach){
        ele=[ele]
      }
      ele.forEach(function(item){
        const replaceAttrVal = item.getAttribute(replaceAttr);
        if(!replaceAttrVal) return;
        item[sourceAttr] = replaceAttrVal;
      })
    };

    /**
     * 懒加载 图片、视频
     * @param {Object} options
     * @param {Element | Element[]} options.target - 目标元素
     * @param {IntersectionObserverInit=} options.observerOptions - IntersectionObserver的参数
     * @param {string=} options.sourceAttr - 源属性，默认为src
     * @param {string | string[] | undefined} options.replaceAttr - 替换属性，默认为data-src,如果是数组，则会找到第一个有值的属性替换
     * @param {{sourceAttr:string,replaceAttr:string | string[]}[]=} options.batchAttrOptions - 批量替换属性 该属性存在时，会忽略上面的sourceAttr、replaceAttr
     */
    const lazyLoad=(options)=>{
        let {target,observerOptions,sourceAttr='src',replaceAttr='data-src',batchAttrOptions} = options;
        let finalAttrOptions = batchAttrOptions || [{sourceAttr,replaceAttr:replaceAttr}];
        if(!target) return;
        if(!target.forEach){
            target=[target]
        }
        if(!target.length) return;
        // 加载资源
        const loadResource=(element)=>{
            // 判断是否为picture标签、video标签、audio标签,如果是的话，需要连带替换source的属性
            const tagName = element.tagName.toLowerCase();
            let targetEle = [element];
            if(['video','audio','picture'].includes(tagName)){
                const sourceEle = element.querySelectorAll('source') || [];
                const imgEle = element.querySelectorAll('img') || [];

                targetEle = targetEle.concat([...sourceEle,...imgEle]);
            }
            targetEle.forEach(function(ele){
                // 替换属性
                finalAttrOptions.forEach(function(item){
                    const {sourceAttr,replaceAttr} = item;
                    let replaceAttrVal='', replaceAttrArr=replaceAttr;
                    if (!Array.isArray(replaceAttr)) {
                        replaceAttrArr = [replaceAttr];
                    }
                    // 找到第一个有值的属性替换
                    replaceAttrArr.some(function(attr){
                        replaceAttrVal = ele.getAttribute(attr);
                        return replaceAttrVal;
                    })
                    // 都没有值则return
                    if(!replaceAttrVal) return;
                    ele[sourceAttr] = replaceAttrVal;
                })
            })
        }
        const observerCallback=(entries, observer)=>{
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                // 进入可视区域，加载图片资源
                const ele = entry.target;
                loadResource(ele);
                // 停止监听
                observer.unobserve(ele);  
            }
          });
        }
        const observer = new IntersectionObserver(observerCallback,observerOptions || { rootMargin: '0px', threshold: 0 });
        target.forEach(function(item){
            observer.observe(item);
        })

        return observer;
    }

    /**
     * 获取指定section的渲染数据
     * @param {string | string[]} sectionName 
     * @returns 
     */
    const getSectionRendering=(sectionName)=>{
        const sectionStr=Array.isArray(sectionName)  ? sectionName.join(','):sectionName;
        let url = window.Shopify.routes.root + `?sections=${sectionStr}`;
        let requestNum=1;

        // 请求section数据
        function fetchSection(){
            return fetch(url).then(res=>res.json()).then((result)=>{
                if(!result) return;
                if(Array.isArray(sectionName)){
                    return result;
                }
                return result[sectionName];
            })
        };

        // 重试
        function retryFetch(){
            return new Promise((resolve,reject)=>{
                fetchSection().then((result)=>{
                    resolve(result);
                }).catch((err)=>{
                    if (requestNum <= 3) {
                        requestNum++;
                        resolve(retryFetch());
                        return;
                    }
                    reject(err);
                })
            })
        }
        return retryFetch();
    }

    class GraphqlHelper {
        // graphql 请求地址
        apiUrl = `/api/2023-10/graphql.json`;
  
        accessToken = '9dc549dfd6ef5c8f26a0ba0260825bf2';
        /**
         * 查询请求
         * @param { string } query  query 参数
         * @param { json } variables 变量
         * @param { string } [accessToken] token
         */
        query(query, variables, accessToken) {
            return fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'x-shopify-storefront-access-token': accessToken ? accessToken: this.accessToken,
                },
                body: JSON.stringify({ query, variables }),
            })
            .then((response) => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw { message: `${response.status}: ${response.statusText}` };
                }
            })
            .catch((err) => {
                return err.message;
            });
        }
    }

    return {
        Toast,
        includeLinkStyle,
        isMobileNumber,
        isMobile,
        copyToClipboard,
        dateFormat,
        formatTimestamp, 
        observerEleReady,
        isValidUrl,
        lazyLoad,
        replaceEleAttribute,
        getSectionRendering,
        GraphqlHelper:new GraphqlHelper()     
    }
})();

